<mat-toolbar class="page-header">
  <div class="menu-container">
    <div class="title-container">
      <div class="pg-title">
        Ashley Homes
      </div>
    </div>

    <div class="filter-container">
      <mat-form-field appearance="outline" floatLabel="never" class="pg-filter">
        <input
          matInput
          placeholder="Search here..."
          autocomplete="off"
          [(ngModel)]="searchText"
          (ngModelChange)="searchChanged()"
        />
        <button
          mat-icon-button
          matSuffix
          class="clear-field-btn"
          (click)="resetTextFilter()"
          *ngIf="searchText"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
        <mat-select
          (ngModelChange)="selectedPolicyStatusList = $event; filter()"
          [ngModel]="selectedPolicyStatusList"
          multiple
        >
          <mat-select-trigger>
            {{ getPolicyStatusDisplay() }}
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search
              (ngModelChange)="filterPolicyStatusSelection($event)"
              (toggleAll)="toggleSelectAllPolicyStatus($event)"
              [ngModelOptions]="{ standalone: true }"
              [searching]="!policyStatusList.length"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxChecked]="isSelectedAllPolicyStatus()"
              [toggleAllCheckboxIndeterminate]="isIndeterminatePolicyStatus()"
              ngDefaultControl
              ngModel
              noEntriesFoundLabel="No matching status found"
              placeholderLabel="Search policy status..."
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let item of filterPolicyStatusList"
            [value]="item.id"
          >
            {{ item.name }}
          </mat-option>
        </mat-select>
        <button
          (click)="toggleSelectAllPolicyStatus(true)"
          *ngIf="!isSelectedAllPolicyStatus()"
          class="clear-field-btn"
          mat-icon-button
          matSuffix
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        floatLabel="never"
        class="pg-filter"
        (click)="lastFilterSelected = filterSelected"
      >
        <mat-select [(ngModel)]="filterSelected">
          <mat-select-trigger>
            <ng-container [ngSwitch]="filterSelected">
              <span *ngSwitchCase="'today'">Today</span>
              <span *ngSwitchCase="'week'">This Week</span>
              <span *ngSwitchCase="'month'">This Month</span>
              <span *ngSwitchCase="'year'">This Year</span>
              <span *ngSwitchCase="'all'">All Time</span>
              <span *ngSwitchDefault>
                <span *ngIf="endDate">
                  {{ startDate | date : "dd/MM/yy" }}
                  - {{ endDate | date : "dd/MM/yy" }}
                </span>
              </span>
            </ng-container>
          </mat-select-trigger>
          <mat-option value="all" (click)="resetDate()">All Time</mat-option>
          <mat-option value="year" (click)="setCurrentYearDate()"
            >This Year</mat-option
          >
          <mat-option value="month" (click)="setCurrentMonthDate()"
            >This Month</mat-option
          >
          <mat-option value="week" (click)="setCurrentWeekDate()"
            >This Week</mat-option
          >
          <mat-option value="today" (click)="setTodayDate()">Today</mat-option>
          <mat-option value="custom" (click)="picker.open()"
            >Custom Range</mat-option
          >
          <!-- NEW DATE PICKER UI  -->
          <mat-date-range-input style="display: none" [rangePicker]="picker">
            <input
              matStartDate
              [(ngModel)]="startDate"
              (dateChange)="onStartDateSelected($event)"
              placeholder="Start date"
            />
            <input
              matEndDate
              [(ngModel)]="endDate"
              (dateChange)="onEndDateSelected($event)"
              placeholder="End date"
            />
          </mat-date-range-input>
          <mat-date-range-picker
            #picker
            (opened)="startDateOpen()"
            (closed)="onDateRangePickerClosed()"
          >
          </mat-date-range-picker>
        </mat-select>
        <button
          mat-icon-button
          matSuffix
          class="clear-field-btn"
          (click)="resetDateFilter()"
          *ngIf="filterSelected !== 'all'"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</mat-toolbar>

<div class="content-container">
  <div class="flex justify-between">
    <button
      appCheckFunctionPermission
      mat-stroked-button 
      color="primary"
      (click)="uploadFile()"
    >
      Upload Confirmation of Cover Listing
    </button>
    <button mat-stroked-button color="primary" (click)="onExportData()">
      Export Data
    </button>
  </div>

  <mat-card class="card-table">
    <table
    (matSortChange)="sortChange($event)"
    [dataSource]="dataSource"
    mat-table
    matSort
    >
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Date Created
        </th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">
          {{ element.createdDate | date : "dd MMM yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="reference_no">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference No.</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.referenceNo }}</td>
      </ng-container>

      <ng-container matColumnDef="insured_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Insured Name</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.insuredName }}</td>
      </ng-container>

      <ng-container matColumnDef="nric">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NRIC / Passport No.</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.identityNo }}</td>
      </ng-container>

      <ng-container matColumnDef="type_coverage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type of Coverage</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.coverageType }}</td>
      </ng-container>

      <ng-container matColumnDef="insured_item">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Insured Item(s)</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.insuredItem  }}</td>
      </ng-container>

      <ng-container matColumnDef="insured_item_category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Insured Item Category</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.insuredItemCategory  }}</td>
      </ng-container>

      <ng-container matColumnDef="fpp_price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>FPP Price</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.fppPrice | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="location_risk">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Location of Risk</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.riskLocation }}</td>
      </ng-container>

      <ng-container matColumnDef="postcode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Postcode</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.postcode }}</td>
      </ng-container>

      <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.state }}</td>
      </ng-container>

      <ng-container matColumnDef="residential_building_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Type of Residential Building</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.residentialBuildingType }}</td>
      </ng-container>

      <ng-container matColumnDef="date_delivery">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Delivery</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.deliveryDate | date : "dd MMM yyyy"}}</td>
      </ng-container>

      <ng-container matColumnDef="policy_start_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Policy Start Date</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.policyStartDate | date : "dd MMM yyyy"}}</td>
      </ng-container>

      <ng-container matColumnDef="policy_end_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Policy End Date</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.policyEndDate | date : "dd MMM yyyy"}}</td>
      </ng-container>

      <ng-container matColumnDef="delivery_order_no">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Delivery Order No./Delivery Invoice</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.deliveryOrderNo  }}</td>
      </ng-container>

      <ng-container matColumnDef="sum_insured">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sum Insured/Price of Item</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.sumInsured | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="email_address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.emailAddress }}</td>
      </ng-container>

      <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
          <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.phone }}</td>
      </ng-container>

      <ng-container matColumnDef="insurerPremiumExclSST">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Insurer's Premium (excluded SST)</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.insurerPremiumExclSST | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="insurerPremiumInclSST">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Insurer's Premium (included SST)</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.insurerPremiumInclSST | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="psToAshleyWithServiceFeeExclSST">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>PS to Ashley with Service Fee (excluded SST)</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.psToAshleyWithServiceFeeExclSST | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="psToAshleyWithServiceFeeInclSST">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>PS to Ashley with Service Fee (included SST)</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.psToAshleyWithServiceFeeInclSST | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="psEarning">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>PS Earning</th>
        <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.psEarning | number : "1.2-2" }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>

        <td mat-cell *matCellDef="let element; dataSource: dataSource" [ngSwitch]="element.status">
          <span class="cover-label green" *ngSwitchCase="'Active'">
            Active
          </span>
          <span class="cover-label red" *ngSwitchCase="'Deactivated'">
            Deactivated
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr *matNoDataRow>
        <td class="mat-cell" colspan="9999">
          <app-empty-record
            *ngIf="!isLoading && list.length === 0"
            [disableSubTitle]="true"
          ></app-empty-record>
          <app-skeleton-loader *ngIf="isLoading"> </app-skeleton-loader>
        </td>
      </tr>
    </table>
    
    <mat-divider></mat-divider>

    <mat-paginator
      #paginator
      [pageSizeOptions]="[50, 100, 150]"
      [pageSize]="limit"
      [length]="length"
      (page)="pageChange($event)"
      aria-label="Select page of users"
    ></mat-paginator>
  </mat-card>
</div>

